import * as ng from 'angular';
import {googleAPI} from '../../../third/googleAPI';
import {ArchiSmallServices} from '../../../services/archismall.service';

export const Dropzone = (ArchiSmallServices: ArchiSmallServices, $rootScope: any, store: ng.a0.storage.IStoreService, configuration: any) => (<angular.IDirective>{

  restrict: 'A',
  transclude: true,

  scope: {
    dropzoneMessage: '@',
  },

  template: `<ng-transclude></ng-transclude><input type='file' multiple style='display:none'/> <div uib-progress max='100' value='0' ></div>`,
  // template: `<ng-transclude></ng-transclude>`,
  link: (scope: any, element: JQLite, attrs: any) => {
    attrs.$observe('dropzoneMessage', (value: any) => {
      if (value) {
        // element.append(transcludeFn(scope)[1]);
        scope.message = attrs.dropzoneMessage;
      }
    });
    if (store.get('conservazioneClasseDocumentale')) {
      switch (store.get('conservazioneClasseDocumentale').value) {
        case 'libro-contabile':
          if (store.get('caricaDocumentoLibroContabile') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'pec-posta-elettronica-certificata':
          if (store.get('caricaPecPostaElettronicaCertificata') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'pec-notifiche-pec':
          if (store.get('caricaPecNotifichePec') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'corrispondenza-ordinaria':
          if (store.get('caricaCorrispondenzaOrdinaria') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'certificazione-unica':
          if (store.get('caricaDocumentoCertificazioneUnica') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'manuali':
          if (store.get('caricaDocumentoManuali') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'modello-intrastat':
          if (store.get('caricaDocumentoModelloIntrastat') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'libri-sociali':
          if (store.get('caricaDocumentoLibriSociali') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'registro-liquidazioni-iva':
          if (store.get('caricaDocumentoRegistroLiquidazioniIva') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'registro-contabile':
          if (store.get('caricaDocumentoRegistroContabile') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'fatture-attive':
          if (store.get('caricaDocumentoFattureAttive') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'modello-dichiarativo':
          if (store.get('caricaDocumentoModelloDichiarativo') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'modello-versamento':
          if (store.get('caricaDocumentoModelloVersamento') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'bollette':
          if (store.get('caricaDocumentoBollette') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'altro-documento':
          if (store.get('caricaDocumentoAltroDocumento') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'fattura-passiva':
          if (store.get('caricaDocumentoFatturaPassiva') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'ddt-attivo':
          if (store.get('caricaDocumentoDDTAttivo') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'ddt-passivo':
          if (store.get('caricaDocumentoDDTPassivo') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'lul':
          if (store.get('caricaDocumentoLUL') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'libro-giornale':
          if (store.get('caricaDocumentoLibroGiornale') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'prima-nota':
          if (store.get('caricaDocumentoPrimaNota') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'giornali-schede-magazzino':
          if (store.get('caricaDocumentoGiornaliSchedeMagazzino') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'libro-inventari':
          if (store.get('caricaDocumentoLibroInventari') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'registro-omaggi':
          if (store.get('caricaDocumentoRegistroOmaggi') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'libro-mastro':
          if (store.get('caricaDocumentoLibroMastro') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'libro-cespiti':
          if (store.get('caricaDocumentoLibroCespiti') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'altri-libri':
          if (store.get('caricaDocumentoAltriLibri') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'registro-corrispettivi-iva':
          if (store.get('caricaDocumentoRegistroCorrispettiviIva') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'dichiarazioni-fiscali':
          if (store.get('caricaDocumentoDichiarazioniFiscali') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;

        case 'ricevute-fiscali':
          if (store.get('caricaDocumentoRicevuteFiscali') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;

        case 'registro-beni-di-terzi':
          if (store.get('caricaDocumentoRegistroBeniDiTerzi') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'registro-unico-iva':
          if (store.get('caricaDocumentoRegistroUnicoIva') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;

        case 'libro-registri-iva':
          if (store.get('caricaDocumentoLibroRegistriIva') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'registro-riepilogativo-iva':
          if (store.get('caricaDocumentoRegistroRiepilogativoIva') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'altri-registri':
          if (store.get('caricaDocumentoAltriRegistri') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'registro-fatture-acquisto':
          if (store.get('caricaDocumentoRegistroFattureAcquisto') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'registro-fatture-vendita':
          if (store.get('caricaDocumentoRegistroFattureVendita') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'modello-f23-f24':
          if (store.get('caricaDocumentoModelloF23F24') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'modello-770':
          if (store.get('caricaDocumentoModello770') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'verbali-verifica-scarto':
          if (store.get('caricaDocumentoVerbaliVerificaScarto') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'nomine-deleghe-conservazione':
          if (store.get('caricaDocumentoNomineDelegheConservazione') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'nomine-deleghe-conservazione':
          if (store.get('caricaDocumentoNomineDelegheConservazione') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;

        case 'modello-730':
          if (store.get('caricaDocumentoModello730') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'verbali-verifica-scarto':
          if (store.get('caricaDocumentoVerbaliVerificaScarto') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'nomine-deleghe-conservazione':
          if (store.get('caricaDocumentoNomineDelegheConservazione') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'schede-cliniche':
          if (store.get('caricaDocumentoSchedeCliniche') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'cm':
          if (store.get('caricaDocumentoCM') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'cmr':
          if (store.get('caricaDocumentoCMR') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'formulario-identificativo-rifiuti':
          if (store.get('caricaDocumentoFormularioIdentificativoRifiuti') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'dichiarazioni-intento-attive':
          if (store.get('caricaDocumentoDichiarazioniIntentoAttive') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'dichiarazioni-intento-passive':
          if (store.get('caricaDocumentoDichiarazioniIntentoPassive') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'documenti-doganali-emessi':
          if (store.get('caricaDocumentoDocumentiDoganaliEmessi') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'documenti-doganali-ricevuti':
          if (store.get('caricaDocumentoDocumentiDoganaliRicevuti') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'modello-unico-dichiarazione-ambientale':
          if (store.get('caricaDocumentoModelloUnicoDichiarazioneAmbientale') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'note-spese-e-trasferte':
          if (store.get('caricaDocumentoNoteSpeseETrasferte') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'ordini-a-fornitore':
          if (store.get('caricaDocumentoOrdiniAFornitore') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'ordini-da-cliente':
          if (store.get('caricaDocumentoOrdiniDaCliente') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'contratti-a-cliente':
          if (store.get('caricaDocumentoContrattiACliente') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'contratti-da-fornitore':
          if (store.get('caricaDocumentoContrattiDaFornitore') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'registro-rifiuti':
          if (store.get('caricaDocumentoRegistroRifiuti') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'pod':
          if (store.get('caricaDocumentoPOD') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
        case 'bilanci':
          if (store.get('caricaDocumentoBilanci') === undefined) {
            $rootScope.filesUploadedNumber = 0;
          }
          break;
      }
    }

    if (store.get('fatturazionePACarica')) {
      if (store.get('fatturazioneCaricaFatturaXML') === undefined) {
        $rootScope.filesUploadedNumber = 0;
      }
    }

    let insertObject = (file, username, dropzoneId) => {
      ArchiSmallServices.validateGoogleAPIToken(googleAPI.getAccessToken())
        .then((response: any) => {
          googleAPI.insertObject(file, dropzoneId, attrs.dropzoneStorageFolder, username, scope.$parent.uploadFileOnGoogleStorageCallback);
          $rootScope.filesUploadedNumber++;
        }, (error) => {
          ArchiSmallServices.getGoogleAPIToken()
            .then((response: any) => {
              googleAPI.setAccessToken(response.accessToken);
              googleAPI.insertObject(file, dropzoneId, attrs.dropzoneStorageFolder, username, scope.$parent.uploadFileOnGoogleStorageCallback);
              $rootScope.filesUploadedNumber++;
            }, (error: any) => {
              $rootScope.alert('error', error);
            });
        });
    };

    let uploadFileOnGoogleStorage = (file, username, dropzoneId) => {

      // user max upload size check
      if ((file.size / 1024 / 1024) > $rootScope.user.limits.maxFileSizeOnUploadMB) {
        $rootScope.alert('error', 'Il file ' + file.name + ' supera il limite di dimensione massimo consentito per l\'upload un singolo file (' + $rootScope.user.limits.maxFileSizeOnUploadMB + ' MB). Se desideri incrementare questo limite puoi contattare il supporto ArchiSMALL.');
        return;
      }

      // usage Percentage check
      ArchiSmallServices.getStorageUsage()
        .then((response: any) => {
          $rootScope.storageUsage = response;

          if (response.subscriptionCancelled) {
            $rootScope.alert('error', 'You can\'t upload files, because your subscription is cancelled');
            return;
          }

          if ($rootScope.storageUsage.usagePercentage >= 100 && $rootScope.storageUsage.isBlockUser) {
            $rootScope.alert('error', 'Hai esaurito lo spazio a disposizione (' + $rootScope.storageUsage.availableSpace + '). Richiedei un incremento di spazio contattando il supporto ArchiSMALL.');
            return;
          }
          insertObject(file, username, dropzoneId);
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    let processDragOverOrEnter = (event) => {
      if (event !== null) {
        event.preventDefault();
      }
      // event.dataTransfer.effectAllowed = 'copy';
      element.addClass('dragOver');
      return false;
    };
    let processDragLeave = (event) => {
      if (event !== null) {
        event.preventDefault();
      }
      element.removeClass('dragOver');
      return false;
    };
    let verifyFiles = (files) => {
      if (files.length === 0) {
        $rootScope.alert('warning', 'Nessun File è stato selezionato!');
        return false;
      }

      if (files.length > attrs.dropzoneMaxFileCount) {
        $rootScope.alert('warning', 'Puoi caricare solo ' + attrs.dropzoneMaxFileCount + ' File(s) !');
        return false;
      }
      /* le docClass qua possono caricare tutte le extension, return true fa uscire senza il check sotto
      * lasciato uno come esempio */

      // if (attrs.classeDocumentale === 'ordini-da-cliente') {
      //   return true;
      // }

      // check files extension
      let accepted_extensions = JSON.parse(attrs.dropzoneAcceptedExtensions.replace(/'/g, '"'));
      let signed_extensions = JSON.parse(attrs.dropzoneSignedExtensions.replace(/'/g, '"'));

      for (let index = 0; index < files.length; index++) {
        let filename = files[index].name.toLowerCase();

        for (let i = 0; i < signed_extensions.length; i++) {
          if ($rootScope.endsWith(filename, '.' + signed_extensions[i])) { // if (filename.endsWith('.' + signed_extensions[i]))
            filename = filename.substring(0, filename.lastIndexOf('.' + signed_extensions[i]));
          }
        }

        let extension = filename.split('.').pop().toLowerCase();

        if ($.inArray(extension, accepted_extensions) === -1) {
          $rootScope.alert('warning', ' ATTENZIONE formato non consentito ai fini della conservazione');
          return false;
        }

        if (files[index].size === 0) {
          $rootScope.alert('warning', 'File ' + files[index].name + ' è vuoto! ');
          return false;
        }

      }

      return true;
    };
    let dropUpload = (event: any) => {
      if (event !== null) {
        event.preventDefault();
      }

      element.removeClass('dragOver');
      if (!verifyFiles(event.originalEvent.dataTransfer.files)) {
        return false;
      }

      let dropzoneId = $(event.target).closest('div[dropzone]').attr('dropzone');
      let files = event.originalEvent.dataTransfer.files;
      let username = '';

      if ($rootScope.user === undefined) {
        username = store.get('registeringUser').accountData.email;
      } else {
        username = $rootScope.user.accountData.email;
      }

      for (let index = 0; index < files.length; index++) {
        let file = files[index];

        if (store.get('registrationJWT') !== undefined && (store.get('jwt') === undefined || store.get('jwt') === null)) {
          insertObject(file, username, dropzoneId);
        } else {
          uploadFileOnGoogleStorage(file, username, dropzoneId);
        }
      }

    };
    let inputUpload = (event: any) => {
      if (event !== null) {
        event.preventDefault();
      }

      if (!verifyFiles(event.target.files)) {
        return false;
      }

      let dropzoneId = $(event.target).closest('div[dropzone]').attr('dropzone');
      let files = event.target.files;
      let username = '';

      if ($rootScope.user === undefined) {
        username = store.get('registeringUser').accountData.email;
      } else {
        username = $rootScope.user.accountData.email;
      }

      for (let index = 0; index < files.length; index++) {
        let file = files[index];

        if (store.get('registrationJWT') !== undefined && (store.get('jwt') === undefined || store.get('jwt') === null)) {
          insertObject(file, username, dropzoneId);
        } else {
          uploadFileOnGoogleStorage(file, username, dropzoneId);
        }
      }
      let $input = $(event.target);
      $input.wrap('<form>').closest('form').get(0).reset();
      $input.unwrap();
    };
    element.bind('dragover', processDragOverOrEnter);
    element.bind('dragenter', processDragOverOrEnter);
    element.bind('dragleave', processDragLeave);
    element.bind('drop', dropUpload);
    element.bind('change', inputUpload);
    element.bind('click', (e) => {
      if (e.originalEvent) {
        $(element).find('input[type=file]').trigger('click');
      }
    });
    let progress = (x) => {
      $('div[dropzone="' + attrs.dropzone + '"]').find('progress').val(x);
    };
  }
});

Dropzone.$inject = ['ArchiSmallServices', '$rootScope', 'store', 'configuration'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/dropzone/dropzone.directive.ts